import { twMerge } from 'tailwind-merge'

export default function EmojiSquares({
  emoji,
  spin,
}: {
  emoji: string
  spin?: boolean
}) {
  return (
    <div className="relative mx-auto h-32 w-32">
      <div
        className={twMerge(
          'absolute inset-0 rotate-[-21deg] rounded-3xl border border-[#2D40FF] bg-transparent',
          spin && 'animate-spin-slow',
        )}
        style={{
          boxShadow: '0 20px 60px 0 rgba(52, 71, 255, 0.40)',
        }}
      ></div>

      <div
        className="absolute inset-0 flex items-center justify-center rounded-3xl bg-gradient-to-b from-[#006BFF] to-[#0560DF]"
        style={{
          boxShadow: '0 20px 60px 0 rgba(52, 71, 255, 0.40)',
        }}
      >
        <span className="mt-2 animate-bounce text-5xl">{emoji}</span>
      </div>
    </div>
  )
}
